import React from 'react';
import { Button } from '../Button';
import cls from '../utils/classnames';
import {
    MUSIC_ACTIONS,
    MUSIC_ACTIONS_HIDDEN,
    MUSIC_ACTIONS_BUTTON,
    MUSIC_ACTIONS_BUTTON_TEXT,
    MUSIC_ACTIONS_BUTTON_ICON,
    MUSIC_ACTIONS_BUTTON_PLAY,
    MUSIC_ACTIONS_BUTTON_TOGGLE_FOLLOW,
    MUSIC_ACTIONS_BUTTON_MORE
} from '../utils/constants';
import './_styles.scss';
import { Hotkey } from '../Hotkey';

export interface IButton {
    buttonText: string;
    iconClassName?: string;
    url?: string;
}

export interface IMusicActionsProps {
    play?: IButton;
    toggleFollow?: IButton;
    more?: IButton;
    onPlayClick?: () => void;
    onToggleFollowClick?: () => void;
    onMoreClick?: () => void;
    isHidden?: boolean;
    onKeyDown: (e: MouseEvent) => void;
    device: 'ps4' | 'default';
}

export class MusicActions extends React.PureComponent<IMusicActionsProps> {
    public componentDidMount(): void {
        const { onKeyDown } = this.props;
        document.removeEventListener('keydown', onKeyDown);
        document.addEventListener('keydown', onKeyDown);
    }

    public componentWillUnmount(): void {
        const { onKeyDown } = this.props;
        document.removeEventListener('keydown', onKeyDown);
    }

    public render(): JSX.Element {
        const {
            play,
            toggleFollow,
            more,
            onPlayClick,
            onToggleFollowClick,
            onMoreClick,
            isHidden = false,
            device
        } = this.props;

        return (
            <div className={cls(MUSIC_ACTIONS, { [MUSIC_ACTIONS_HIDDEN]: isHidden })}>
                {play && (
                    <Button
                        type="button"
                        onClick={(): void => {
                            if (typeof onPlayClick === 'function') onPlayClick();
                        }}
                        className={cls(
                            MUSIC_ACTIONS_BUTTON,
                            MUSIC_ACTIONS_BUTTON_PLAY,
                            'focusable',
                            'firstButton'
                        )}
                    >
                        <span className={cls(MUSIC_ACTIONS_BUTTON_ICON, play.iconClassName)} />
                        <span className={MUSIC_ACTIONS_BUTTON_TEXT}>{play.buttonText}</span>
                        <Hotkey type="type-d" device={device} />
                    </Button>
                )}
                {toggleFollow && (
                    <Button
                        type="button"
                        onClick={(): void => {
                            if (typeof onToggleFollowClick === 'function') onToggleFollowClick();
                        }}
                        className={cls(
                            MUSIC_ACTIONS_BUTTON,
                            MUSIC_ACTIONS_BUTTON_TOGGLE_FOLLOW,
                            'focusable'
                        )}
                    >
                        <span
                            className={cls(MUSIC_ACTIONS_BUTTON_ICON, toggleFollow.iconClassName)}
                        />
                        <span className={MUSIC_ACTIONS_BUTTON_TEXT}>{toggleFollow.buttonText}</span>
                        <Hotkey type="type-b" device={device} />
                    </Button>
                )}
                {more && (
                    <Button
                        type="button"
                        onClick={(): void => {
                            if (typeof onMoreClick === 'function') onMoreClick();
                        }}
                        className={cls(
                            MUSIC_ACTIONS_BUTTON,
                            MUSIC_ACTIONS_BUTTON_MORE,
                            'focusable'
                        )}
                    >
                        <span className={cls(MUSIC_ACTIONS_BUTTON_ICON, more.iconClassName)} />
                        <span className={MUSIC_ACTIONS_BUTTON_TEXT}>{more.buttonText}</span>
                        <Hotkey type="type-c" device={device} />
                    </Button>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/packages/components/lib/MusicActions/index.tsx